import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

@Pipe({
  name: 'customDate',
  standalone: true,
})
export class CustomDatePipe implements PipeTransform {
  transform(
    value: Date | string,
    format = 'DD',
    lang = 'fr',
    useBreakLine = false,
  ): string {
    const shortDays = {
      fr: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
    };
    const date = dayjs(value);
    if (!date.isValid()) {
      console.warn('Valeur de date invalide:', value);
      return '';
    }
    dayjs.locale(lang);
    const dayIndex = date.isoWeekday() - 1;
    const day = shortDays[lang]?.[dayIndex] || date.format('ddd');
    const dayNumber = date.format(format);
    if (useBreakLine) {
      return `<span>${day}</span><br/><span>${dayNumber}</span>`;
    } else {
      return `${day} ${dayNumber}`;
    }
  }
}
